import React, { useState } from 'react';
import { Popover, List, ListItem, ListItemText } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { IconButton } from '@material-ui/core';
import MoreVertIcon from '@material-ui/icons/MoreVert';
import Popup from '../../../Modal/PopUp';
import {updateDefaultCard, deleteCard} from '../../../../store/actions/UserAction';
import { connect } from 'react-redux';

import './CardSaved.scss';

const useStyles = makeStyles({
  button: {
    padding: '8px 0',
    '&:hover': {
      backgroundColor: 'transparent',
    },
  },
  list: {
    width: 176,
    backgroundColor: 'white',
  },
  listItem: {
    paddingLeft: 16,
    paddingRight: 13,
    '&:hover': {
      backgroundColor: '#f5f5f5',
    },
  },
  listItemText: {
    color: '#484848',
    fontSize: 14,
  },
  popper: {
    width: 176,
    margin: '0 24px 0 0',
    //boxShadow: isMobile ? 'initial' : '0 2px 5px 0 rgba(0, 0, 0, 0.2)',
    //backgroundColor: isMobile ? 'initial' : '#f5f5f5',
  },
});

const CardSaved = ({  info, numItem, updateDefaultCard,deleteCard, billing}) => {
  const classes = useStyles()
  
  const [ anchorEl, setAnchorEl ] = useState(null)
  const [ outsideOpen, setOutsideOpen ] = useState(false)
  //const [option, setOption] = useState({ delete: false, setDefault: false });
  const [popupContent, setPopupContent] = useState({
    title: '',
    subtitle: '',
    button: '',
    option: '',
  });

  const openPopper = Boolean(anchorEl);

  const handlePopper = (event) => {
    setAnchorEl(anchorEl ? null : event.currentTarget);
  };

  const handleOutside = () => {
    setOutsideOpen(!outsideOpen);

  };

  const confirmDeleteCard = (event) => {
    event.preventDefault();
    handleOutside();
    console.log('Eliminar')
    
  };

  const confirmDefault = (event) => {
    event.preventDefault();
    handleOutside();
    console.log('Predeterminada')
    
  };

  const handleSetDefault = () => {
    setAnchorEl(null);
    setPopupContent({
      title: '¿Deseas marcar esta tarjeta como predeterminada?',
      subtitle: 'Si continuas con este proceso deberemos realizar un cargo mínimo a tu tarjeta para comprobar que cuente con los fondos suficientes.',
      button: 'Sí, continuar',
      option: 'setDefault'
    });
    
    updateDefaultCard(info.id, billing)
    .then(res=> console.log(res))
    .catch(error => {
      console.log(error)
    });  
  };

  const handleDelete = () => {
    setAnchorEl(null);
    setPopupContent({
      title: '¿Quieres eliminar la tarjeta seleccionada?',
      subtitle:
        'Si eliminas esta tarjeta desarapecerá de tu lista y la información de la misma no podrá ser recuperada. Si no deseas continuar da click en el botón Cancelar.',
      button: 'Sí, eliminar',
      option: 'delete'
    });

     deleteCard(info.id, billing)
    .then(res=> console.log(res))
    .catch(error => {
      console.log(error)
    });  
    
  };

  const handleCancel = () => {
    setAnchorEl(null);
    handleOutside();
    
  };
  return (
    <>
      <Popup
        open={outsideOpen}
        handleClose={handleOutside}
        title={popupContent.title}
        subtitle={popupContent.subtitle}
        primaryButton={true}
        primaryButtonVariant="primarySolidOutlined"
        primaryButtonText={popupContent.button}
        primaryFunction={popupContent.option === 'delete' ? confirmDeleteCard : confirmDefault}
        secondaryButton={true}
        secondaryOptionalFunctionForCancel={handleCancel}
        secondaryButtonVariant="primary"
      />
      <div className="cardSaved">
        <div className="cardSaved-card">
          <div className="cardSaved-content">
            <img
              className="cardSaved-image"
              src="/img/payment/mastercard.jpg"
              alt="tipo de tarjeta"
            />
            <div className="cardSaved-info">
              <p>{info && info.name}</p>
              <div>
                <p>Tarjeta terminación {info && info.last4}</p>
                <p>
                  Vencimiento {info && info.exp_month}/{info && info.exp_year}/
                </p>
              </div>
            </div>
          </div>
          {  numItem === 0 ? (
            null
          ) : (
            <IconButton
              disableFocusRipple
              disableRipple
              classes={{ root: classes.button }}
              onClick={handlePopper}
            >
              <MoreVertIcon color="primary" />
            </IconButton>
          )}
        </div>
        { numItem === 0 && (
          <span className="cardSaved-caption">Tarjeta predeterminada</span>
        )}
      </div>
      <Popover
        open={openPopper}
        anchorEl={anchorEl}
        //className={classes.popper}
        onClose={() => setAnchorEl(null)}
        anchorOrigin={{
          vertical: 'center',
          horizontal: 'right',
        }}
      >
        <List className={classes.list} component="nav" aria-label="options">
          <ListItem className={classes.listItem} button disableGutters>
            <ListItemText
              onClick={handleSetDefault}
              className={classes.listItemText}
              disableTypography
              primary="Marcar predeterminada"
            />
          </ListItem>

          <ListItem className={classes.listItem} button disableGutters>
            <ListItemText
              onClick={handleDelete}
              className={classes.listItemText}
              disableTypography
              primary="Eliminar tarjeta"
            />
          </ListItem>
        </List>
      </Popover>
    </>
  );
};

const mapDispatchToProps = (dispatch) => ({
  updateDefaultCard:(idCard, billing) => dispatch( updateDefaultCard(idCard, billing)),
  deleteCard:(idCard, billing) => dispatch( deleteCard(idCard, billing))

});

const mapStateToProps = (state) => ({
  billing: state.billingReducer.billingData,
});

export default connect(mapStateToProps, mapDispatchToProps)(CardSaved);
